import Immutable from 'immutable';
import { SET_SUBSCRIPTION_PLANS } from './actions';

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function SubscriptionPlans(state = Immutable.Map(), action = {}) {
  switch (action.type) {
    case SET_SUBSCRIPTION_PLANS: {
      const subscriptionPlans = Immutable.fromJS(action.subscriptionPlans);
      let newState = state;
      subscriptionPlans.forEach((subscriptionPlan) => {
        newState = newState.set(
          subscriptionPlan.get('planId'),
          subscriptionPlan
        );
      });
      return newState;
    }
    default: {
      return state;
    }
  }
}
